module.exports = __webpack_public_path__ + "img/s4-v2.fd80a06a.png";